export default __webpack_public_path__ + "static/media/Albarka_Logo_PNG.edd3812b.png";